import { Box } from "@bcc-ui/ui-components";
import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";
import { connect, ConnectedProps } from "react-redux";

import Info from "components/icons/Info";
import CircleWithNumber from "components/products/CircleWithNumber";
import style from "components/products/getting-started.scss";
import Tooltip from "components/tooltip/Tooltip";
import { StoreState } from "store";
import { useTheme } from "utils/useTheme";

interface Props {
    iconNumber: number;
    translationKey: string;
    className?: string;
    subStep: boolean;
    tooltipText?: string;
    hasCards?: boolean;
    additionalSteps?: string[];
}

const mapState = (state: StoreState) => ({
    theme: state.themeReducer.theme,
    user: state.userReducer.user,
});

const connector = connect(mapState);

const SubStep = (props: Props & ConnectedProps<typeof connector>): JSX.Element => {
    const { t } = useTranslation();
    const theme = useTheme();
    return (
        <>
            <Box className={style.subStepsToFollowLayout}>
                <Box columnLayout={!!props.additionalSteps} gap="Sm">
                    <Box>
                        {<CircleWithNumber number={props.iconNumber} subStep={props.subStep} />}
                        <div className={classNames(style.subSteps)}>
                            {t(props.translationKey)}
                            {props.tooltipText && (
                                <Tooltip content={props.tooltipText} placement={"right-end"}>
                                    <span className={style.tooltipSpacing}>
                                        <Info
                                            borderColor={theme.contentBackgroundColor}
                                            color={theme.sortIconActiveColor}
                                            size={"14"}
                                        />
                                    </span>
                                </Tooltip>
                            )}
                        </div>
                    </Box>
                    {props.additionalSteps && (
                        <Box columnLayout marginLeft="Lg">
                            <ul className={style.additionalStepsList}>
                                {props.additionalSteps.map((additionalStep) => (
                                    <li key={additionalStep} className={style.additionalSteps}>
                                        {t(additionalStep)}
                                    </li>
                                ))}
                            </ul>
                        </Box>
                    )}
                </Box>
            </Box>
        </>
    );
};

export default connector(SubStep);
